import {
  DefaultFetchError, FetchCreate, useFetchCreate,
} from '../fetch';

export interface LoginAsUserPayload {
  userId: string;
}

export interface LoginAsUserResponse {
  requiresOtpVerification: boolean;
}

export const useAdminLoginAsUser = (): FetchCreate<
  LoginAsUserResponse, DefaultFetchError, LoginAsUserPayload> => (
  useFetchCreate('auth/admin/login-as-user')
);

export interface LoginAsUserVerifyPayload {
  userId: string;
  code: string;
}

export interface LoginAsUserVerifyResponse {
  ssoCode: string;
  expiresAt: string;
}

export const useAdminLoginAsUserVerify = (): FetchCreate<
  LoginAsUserVerifyResponse, DefaultFetchError, LoginAsUserVerifyPayload> => (
  useFetchCreate('auth/admin/login-as-user/verify')
);
